// extracted by mini-css-extract-plugin
module.exports = {"notion-container":"Notion_notion-container__1n3ps","eli-container":"Notion_eli-container__21gzM"};